import { gql } from '@apollo/client';

export const GET_TRAINING_MATERIAL_UPLOAD_URL = gql(/* GraphQL */ `
    mutation GetTrainingMaterialUploadUrl(
        $fileName: String!
        $fileType: String!
        $categoryId: Int!
        $fileSize: Int!
    ) {
        getTrainingMaterialUploadUrl(
            fileName: $fileName
            fileType: $fileType
            categoryId: $categoryId
            fileSize: $fileSize
        ) {
            url
            s3Key
        }
    }
`);

export const GET_TRAINING_MATERIAL_THUMBNAIL_UPLOAD_URL = gql(/* GraphQL */ `
    mutation GetTrainingMaterialThumbnailUploadUrl(
        $fileS3Key: String!
        $categoryId: Int!
    ) {
        getTrainingMaterialThumbnailUploadUrl(
            fileS3Key: $fileS3Key
            categoryId: $categoryId
        ) {
            url
            s3Key
        }
    }
`);

export const CREATE_TRAINING_MATERIAL = gql(/* GraphQL */ `
    mutation CreateTrainingMaterial($input: CreateTrainingMaterialInput!) {
        createTrainingMaterial(input: $input) {
            id
            title
            description
            s3Key
            fileName
            fileSize
            fileType
            thumbnailS3Key
            thumbnailUrl
            categoryId
            createdAt
        }
    }
`);

export const ABORT_TRAINING_MATERIAL_UPLOAD = gql(/* GraphQL */ `
    mutation AbortTrainingMaterialUpload(
        $input: AbortTrainingMaterialUploadInput!
    ) {
        abortTrainingMaterialUpload(input: $input)
    }
`);

export const UPDATE_TRAINING_MATERIAL = gql(/* GraphQL */ `
    mutation UpdateTrainingMaterial($input: UpdateTrainingMaterialInput!) {
        updateTrainingMaterial(input: $input) {
            id
            title
            description
            categoryId
        }
    }
`);

export const DELETE_TRAINING_MATERIAL = gql(/* GraphQL */ `
    mutation DeleteTrainingMaterial($id: Int!) {
        deleteTrainingMaterial(id: $id)
    }
`);

export const CREATE_TRAINING_CATEGORY = gql(/* GraphQL */ `
    mutation CreateTrainingCategory($input: CreateTrainingCategoryInput!) {
        createTrainingCategory(input: $input) {
            id
            name
            description
            sortOrder
            audiences
        }
    }
`);

export const UPDATE_TRAINING_CATEGORY = gql(/* GraphQL */ `
    mutation UpdateTrainingCategory($input: UpdateTrainingCategoryInput!) {
        updateTrainingCategory(input: $input) {
            id
            name
            description
            sortOrder
            audiences
        }
    }
`);

export const REORDER_TRAINING_CATEGORIES = gql(/* GraphQL */ `
    mutation ReorderTrainingCategories($input: ReorderTrainingCategoryInput!) {
        reorderTrainingCategories(input: $input) {
            id
            name
            sortOrder
        }
    }
`);

export const DELETE_TRAINING_CATEGORY = gql(/* GraphQL */ `
    mutation DeleteTrainingCategory($id: Int!) {
        deleteTrainingCategory(id: $id)
    }
`);
